import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button, Flex,
  Table,
  Tbody,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import axios from "axios";
import { ProductType } from "models/product_type";
import {
  Project,
  ProjectCategory,
  ProjectCategoryItem
} from "models/project_type";
import { useEffect, useRef, useState } from "react";
import useMeasureUnit from "views/admin/order/measureUnit/hooks/useMeasureUnit";
import FinanceItemRow from "./FinanceItemRow";

interface IItemTable {
  item: ProjectCategory | undefined;
  borderColor: string;
  index: number;
  changeItem: (item: ProjectCategory) => void;
  accountSelected: Project;
  calcula : () => void;
  calculaManejo : () => void;
}

const ItemTableProject = ({
  item,
  borderColor,
  index,
  changeItem,
  accountSelected,
  calcula,
  calculaManejo,
}: IItemTable) => {
  const [categoryItens, setCategoryItens] = useState<ProjectCategoryItem[]>([]);
  const [produtos, setProdutos] = useState<ProductType[]>([]);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const { unidades } = useMeasureUnit();
  const cancelRef = useRef(null);

  const calculaValor = (data: ProjectCategoryItem[]) => {
    let soma = 0;
    data.forEach((item) => {
      soma = soma + Number(item.valorTotal);
    });
    return soma;
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };
  const closeError = () => {
    setError(false);
  };

  const editItem = (data: ProjectCategoryItem, tipo: string, value: string) => {
    const categ = accountSelected?.Orcamento?.OrcamentoCategoria?.find(
      (ca) => ca.descricao === item.descricao
    );

    switch (tipo) {
      case "produto":
        const existe = item.ProjetoItem.find((a) => a.produtoId === value);

        if (existe) {
          showError(
            "Erro!",
            "Produto já está na lista, procure editar esse produto!"
          );
        } else {
          item.ProjetoItem = item.ProjetoItem.map((findItem) => {
            if (data.descricao === findItem.descricao) {
              const novoProduto = produtos?.find((a) => a.id === value);
              const unidadePricipal = novoProduto?.ProdutoUnidade.find(
                (b) => b.principal
              );
              const unidadeSecundaria = novoProduto?.ProdutoUnidade[0];
              const valorMedioPrincipal =
                Number(
                  novoProduto?.ProdutoUnidade.find((b) => b.principal)?.valorMin
                ) +
                Number(
                  novoProduto?.ProdutoUnidade?.find((b) => b.principal)
                    ?.valorMax
                ) /
                  2;
              const valorMedioSecundario =
                Number(novoProduto?.ProdutoUnidade[0].valorMin) +
                Number(novoProduto?.ProdutoUnidade[0].valorMax) / 2;
              findItem.produtoId = novoProduto.id;
              findItem.produtoNome = novoProduto.nome;
              findItem.descricao = novoProduto.nome;
              findItem.unidadeMedidaId =
                unidadePricipal?.unidadeMedidaId ??
                unidadeSecundaria?.unidadeMedidaId;
              findItem.produtoUnidadeId =
                unidadePricipal?.id ?? unidadeSecundaria.id;
              findItem.unidadeNome =
                unidades?.find((a) => a.id === unidadePricipal?.unidadeMedidaId)
                  ?.nome ??
                unidades?.find(
                  (a) => a.id === unidadeSecundaria?.unidadeMedidaId
                )?.nome;
              findItem.valorUn = valorMedioPrincipal ?? valorMedioSecundario;
              findItem.valorTotal = findItem.quantidade * findItem.valorUn;
              findItem.produtoUnidade = novoProduto.ProdutoUnidade;
            }

            return findItem;
          });
        }
        break;

      case "descricao":
        item.ProjetoItem = item.ProjetoItem.map((findItem) => {
          if (data.descricao === findItem.descricao) {
            findItem.descricao = value;
          }
          return findItem;
        });
        break;

      case "unidade":
        item.ProjetoItem = item.ProjetoItem.map((findItem) => {
          if (data.descricao === findItem.descricao) {
            const novoProduto = produtos.find(
              (a) => a.id === findItem.produtoId
            );
            const selectedUnidade = novoProduto.ProdutoUnidade.find(
              (a) => a.unidadeMedidaId === value
            );

            if (selectedUnidade) {
              const valorMedio =
                (Number(selectedUnidade.valorMin) +
                  Number(selectedUnidade.valorMax)) /
                2;
              findItem.produtoUnidadeId = value;
              findItem.valorUn = valorMedio;
              findItem.valorTotal = valorMedio * findItem.quantidade;
            }
          }
          return findItem;
        });
        break;

      case "quantidade":
        item.ProjetoItem = item.ProjetoItem.map((findItem) => {
          if (data.descricao === findItem.descricao) {
            findItem.quantidade = Number(value);
            findItem.valorTotal = Number(value) * findItem.valorUn;
          }
          return findItem;
        });
        break;

      case "valor":
        item.ProjetoItem = item.ProjetoItem.map((findItem) => {
          const defaultItem = categ.OrcamentoItem?.find(
            (ct) => ct.produtoId === findItem.produtoId
          );
          let diff = 0;
          if (data.descricao === findItem.descricao) {
            const valorToCompare = Number(value);
            findItem.valorUn = valorToCompare;
            findItem.valorTotal = findItem.valorUn * findItem.quantidade;
            diff = diff + (defaultItem.valorTotal - findItem.valorTotal);
            if (diff < 0) {
              diff = diff * -1;
            }
          }
          item.valorReducao = diff.toString();
          return findItem;
        });

        break;

      case "travado":
        item.ProjetoItem = item.ProjetoItem.map((findItem) => {
          const defaultItem = categ.OrcamentoItem?.find(
            (ct) => ct.produtoId === findItem.produtoId
          );
          if (data.descricao === findItem.descricao) {
            if (!findItem.travado) {
              findItem.valorUn = defaultItem.valorUn;
              findItem.valorTotal = defaultItem.valorTotal;
              findItem.quantidade = defaultItem.quantidade;
              findItem.unidadeMedidaId = defaultItem.unidadeMedidaId;
              findItem.produtoId = defaultItem.produtoId;
              findItem.valorManejo = "0";
              findItem.porcentagemManejo = "0";
              findItem.valorReducao = "0";
              findItem.porcentagemReducao = "0";
            }

            findItem.travado = !findItem.travado;
          }
          return findItem;
        });

        break;

      case "reducao":

        item.ProjetoItem = item.ProjetoItem.map((findItem) => {
          const defaultItem = categ.OrcamentoItem?.find(
            (ct) => ct.produtoId === findItem.produtoId
          );
          if (data.descricao === findItem.descricao) {
            var calc = (Number(defaultItem.valorTotal) * Number(value)) / 100;
            findItem.valorReducao = calc.toString();
            findItem.porcentagemReducao = value;
            findItem.valorUn =
              defaultItem.valorUn -
              (Number(defaultItem.valorUn) * Number(value)) / 100;
            findItem.valorTotal = findItem.valorUn * findItem.quantidade;
          }
          return findItem;

        });
        
        item.valorReducao = item.ProjetoItem.reduce((acc, pr) => acc + Number(pr.valorReducao), 0).toString();
        const valor = Number(item.valorReducao);
        const total = ( (valor/ categ.valor) * 10) ;    
        item.porcentagemReducao =  total.toFixed(4)


        break;

      case "manejo":  
        item.ProjetoItem = item.ProjetoItem.map((findItem) => {
          if (data.descricao === findItem.descricao) {
            const calc = (Number(findItem.valorTotal) * Number(value)) / 100;
            findItem.porcentagemManejo = value;
            findItem.valorManejo = calc.toFixed(2);
          }
          return findItem;
        });
        item.valorManejo = item.ProjetoItem.reduce((acc, pr) => acc + Number(pr.valorManejo), 0).toString();
        const totalManejo = ((Number(item.valorManejo) / categ.valor) * 10)     
        item.porcentagemManejo =  totalManejo.toFixed(4)
        break;

      default:
        break;
    }
    item.valor = calculaValor(item.ProjetoItem);
    changeItem(item);
    setCategoryItens(item.ProjetoItem);
    calculaManejo();
    calcula();
  };
  useEffect(() => {
    const loadData = async () => {
      const userData = JSON.parse(localStorage.getItem("user"));
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/produto/list/" + userData?.idEmpresa
      );
      if (response.data) {
        setProdutos(response.data);
      }
    };

    const loadItens = () => {
      if (item?.ProjetoItem?.length > 0) {
        setCategoryItens(item.ProjetoItem);
      }
    };

    loadItens();
    loadData();
  }, [item.ProjetoItem]);

  return (
    <>
      <Table
        variant="striped"
        color="gray.500"
        mb="24px"
        mt="96px"
        key={`${index}`}
      >
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #ITEM
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #UNIDADE
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #QTD
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #VALOR UN
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #TOTAL
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                # % REDUZIDO
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #REDUZIDO
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                # % MANEJADO
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #MANEJADO
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OPÇÕES
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {categoryItens.map((item1, index1) => (
            <FinanceItemRow
              editItem={editItem}
              index={index}
              index1={index1}
              item1={item1}
              produtos={produtos}
              unidades={unidades}
            />
          ))}
        </Tbody>
      </Table>
      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
export default ItemTableProject;
